/**
 * getUserBestWorst.js
 * Written by: Li Liu
 */
import request from '../../../request/actions';

export const GET_USER_BEST_WORST_START = `GET_USER_BEST_WORST_START`;
export const GET_USER_BEST_WORST_SUCCESS = `GET_USER_BEST_WORST_SUCCESS`;
export const GET_USER_BEST_WORST_FAILURE = `GET_USER_BEST_WORST_FAILURE`;

export const getUserBestWorstStart = () => ({
  type: GET_USER_BEST_WORST_START,
});

export const getUserBestWorstSuccess = (data, id) => ({
  type: GET_USER_BEST_WORST_SUCCESS,
  data,
  id,
});

export const getUserBestWorstFailure = (error) => ({
  type: GET_USER_BEST_WORST_FAILURE,
  error,
});

/**
 * Description of the getUserBestWorst action
 */
export const getUserBestWorst = (id) => {
  return async (dispatch) => {
    dispatch(getUserBestWorstStart());
    try {
      const response = await dispatch(request(`/users/${id}/best_worst_categories/`, `GET`));
      dispatch(getUserBestWorstSuccess(response.data, id));
    } catch (e) {
      dispatch(getUserBestWorstFailure(e));
    }
  };
};

export default getUserBestWorst;

